import {
  Home24Regular,
  Home24Filled,
  CalendarLtr24Regular,
  CalendarLtr24Filled,
  DataBarVertical24Regular,
  DataBarVertical24Filled,
  CalendarLtr20Regular,
  CalendarLtr20Filled,
  List20Regular,
  List20Filled,
  DocumentData20Regular,
  DocumentData20Filled,
  DataBarVertical20Regular,
  DataBarVertical20Filled,
} from '@fluentui/react-icons';
import {
  AdminPersonaIcon24Regular,
  AdminPersonaIcon24Filled,
} from '@components/common/AdminPersonaIcon';
import type { RailItem, RailSubItem } from '@/types/leftNavRail.types';
import { ROUTES } from './routeConstants';

export const PLANNER_SUB_ITEMS: readonly RailSubItem[] = [
  {
    key: 'event-list',
    labelKey: 'planner:leftNav.eventList',
    icon: List20Regular,
    iconActive: List20Filled,
    route: ROUTES.PLANNER_EVENT_LIST,
    testId: 'rail-subitem-event-list',
  },
  {
    key: 'calendar-view',
    labelKey: 'planner:leftNav.calendarView',
    icon: CalendarLtr20Regular,
    iconActive: CalendarLtr20Filled,
    route: ROUTES.PLANNER_CALENDAR_VIEW,
    testId: 'rail-subitem-calendar-view',
  },
  {
    key: 'metrics-report',
    labelKey: 'planner:leftNav.metricsReport',
    icon: DataBarVertical20Regular,
    iconActive: DataBarVertical20Filled,
    route: ROUTES.PLANNER_METRICS_REPORT,
    testId: 'rail-subitem-metrics-report',
  },
];

export const PLANNER_DEFAULT_SUB_ROUTE = ROUTES.PLANNER_EVENT_LIST;

export const REPORTS_SUB_ITEMS: readonly RailSubItem[] = [
  {
    key: 'report-summary',
    labelKey: 'planner:leftNav.reportSummery',
    icon: DocumentData20Regular,
    iconActive: DocumentData20Filled,
    route: ROUTES.REPORTS_REPORT_SUMMARY,
    testId: 'rail-subitem-report-summary',
  },
];

export const REPORTS_DEFAULT_SUB_ROUTE = ROUTES.REPORTS_REPORT_SUMMARY;

export const RAIL_ITEMS: readonly RailItem[] = [
  {
    key: 'home',
    labelKey: 'common:leftNav.home',
    icon: Home24Regular,
    iconActive: Home24Filled,
    defaultRoute: ROUTES.HOME,
    extraActivePrefixes: [ROUTES.BOOKINGS],
    testId: 'rail-item-home',
  },
  {
    key: 'planner',
    labelKey: 'common:leftNav.planner',
    icon: CalendarLtr24Regular,
    iconActive: CalendarLtr24Filled,
    defaultRoute: PLANNER_DEFAULT_SUB_ROUTE,
    allowedPersonas: ['Admin', 'Planner'],
    children: PLANNER_SUB_ITEMS,
    testId: 'rail-item-planner',
  },
  {
    key: 'reports',
    labelKey: 'common:leftNav.reports',
    icon: DataBarVertical24Regular,
    iconActive: DataBarVertical24Filled,
    defaultRoute: REPORTS_DEFAULT_SUB_ROUTE,
    allowedPersonas: ['Admin', 'Planner'],
    children: REPORTS_SUB_ITEMS,
    hidden: true,
    testId: 'rail-item-reports',
  },
  {
    key: 'admin',
    labelKey: 'common:leftNav.admin',
    icon: AdminPersonaIcon24Regular,
    iconActive: AdminPersonaIcon24Filled,
    defaultRoute: ROUTES.ADMIN,
    allowedPersonas: ['Admin'],
    // Hidden from the rail while the Admin module is work in progress.
    hidden: true,
    testId: 'rail-item-admin',
  },
];
